<template>
  <div
    ref="welcome"
    class="welcome full-screen"
    :style="{ backgroundImage: `url('${src}')` }"
    :data-is-hide="!isShowingWelcome"
  >
    <span class="count">{{ count }}</span>
    <button class="skip" @click="hideWelcome">{{$t("welcome.into")}}</button>
  </div>
</template>

<script>
import { show, hide } from '@/assets/js/methods/fullscreen'

export default {
  data: () => ({
    isShowingWelcome: true,
    count: 5,
    countDownTime: null
  }),
  props: {
    src: String
  },
  methods: {
    showWelcome () {
      this.isShowingWelcome = true
      show(this.$refs.welcome)
    },
    hideWelcome () {
      clearInterval(this.countDownTime)
      hide(this.$refs.welcome)
      this.isShowingWelcome = false
      // setTimeout(()=>{
      //   window.scrollTo(0, 10)
      // }, 1000)
    },
    startCountDown () {
      if (this.count > 1) {
        this.count -= 1
        this.countDownTime = setTimeout(this.startCountDown, 1000)
      } else {
        this.hideWelcome()
      }
    }
  },
  mounted () {
    this.startCountDown()
    this.showWelcome()
  }
}
</script>
